export default __webpack_public_path__ + "static/media/7Auwp_0qiz-afT3GLRrX.fa72d97c.woff2";